var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"header"}}),_c('div',[_c('router-view',{key:_vm.$route.fullPath})],1),_c('router-view',{attrs:{"name":"footer"}}),_c('CookieBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }